import React from 'react';


const RejectedPage = () => {
    return (
        <React.Fragment>
            <div className="container-form-5">
                <div className="d-flex justify-content-center" style={{ height: 150, alignItems: 'center' }}>
                    <span className="text-3" style={{ width: 'auto', height: 'auto', textAlign: 'center' }}>
                        Usted ha rechazado el <b className="text-3 text-bold">Acuerdo de confidencialidad</b><br />
                        por lo que no podemos seguir con el proceso. <br /> <br />
                        <span className="text-3 sub-text">
                            Si desea iniciar un piloto con nosotros deberá aceptar el contrato e iniciar el proceso de nuevo
                        </span>
                    </span>
                </div>
            </div>
        </React.Fragment>
    )
};

export default RejectedPage;
